import { createFichierOperationFragment } from '@lib/models/graphqlFragments';
import { gql } from 'apollo-angular';

export const refreshOperationDocumentsMutation = gql`
  mutation refreshOperationDocuments($input: RefreshOperationDocumentsInput!) {
    refreshOperationDocuments(input: $input) {
      ...createFichierOperation
    }
  }
  ${createFichierOperationFragment}
`;
